<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="search.deliveryOrdeNo"
          placeholder="WMS进仓号"
          right-icon="scan"
          @click-right-icon="scanSku"
          @keyup.13="getList('search')"
        />
        <van-field
          size="small"
          v-model="search.orgCustomerNo"
          placeholder="参考单号"
          :formatter="relationNumberFmt"
          @keyup.13="getList('search')"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList('search')">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            ref="vList"
            @load="onLoad"
          >
            <ul>
              <li
                @click="toSignInDetail(item)"
                v-for="(item, index) in list"
                :key="index"
              >
                <div>
                  <div class="sign-list">
                    <p>进仓单号：{{ item.deliveryOrdeNo }}</p>
                    
                  </div>
                  <div class="sign-list">
                    <p>参考单号：{{ item.orgCustomerNo }}</p>
                  </div>
                  <div class="sign-list">
                    <p>客户：{{ item.customName }}</p>
                    <p>目的地：{{ item.destination }}</p>
                  </div>
                  <div class="sign-list">
                    <p>进度：{{ item.scanningBoxCount }}/{{ item.actualBoxCount }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </van-list>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
} from "vant";
import { getList } from "@/api/mobile/jy-receiptGoods_api";
import { mapState } from "vuex";
import util from "util/date";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      showPicker: false,
      value: "",
      columns: [],
      search: {
        page: 1,
        pageSize: 10,
        orgCustomerNo: "",
        deliveryOrdeNo: "",
      },
      list: [],
      customerList: [],
      loading: false,
      finished: false,
      startSearch: false,
      isReadonly: false,
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Field.name]: Field,
  },

  mixins: [mixins],

  created() {},

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  methods: {
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "deliveryOrdeNo", a.resultStr);
        },
      });
    },
    getList(type) {
      if (type === "search") {
        this.list = [];
        this.finished = false;
        this.search.page = 1;
      }

      const data = {
        ...this.search,
      };

      if (this.search.page === 1) {
        this.startSearch = true;
      }
      getList(data).then((res) => {
        this.loading = false;
        this.startSearch = false;
        if (res.status === 200) {
          const { pageData, pageCount, pageIndex } = res.response;

          if (!pageData.length) Toast("暂无匹配数据");

          try {
            pageData.forEach((row) => {
              row.estimatedDate = util.formatDate.format(
                new Date(row.estimatedDate),
                "yyyy-MM-dd"
              );
            });
          } catch {}

          if (pageCount === pageIndex) {
            this.finished = true;
          }

          this.list.push(...pageData);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    toSignInDetail(item) {
      const { deliveryOrdeNo } = item;
      this.$router.push({
        path: "/mobile/jy-receiptGoodsDetail",
        query: { deliveryOrdeNo },
      });
    },
    onLoad() {
      this.search.page++;

      this.getList();
    },
    relationNumberFmt(v) {
      return v.trim();
    },
  },
  mounted() {
		this.getList("search");
	}
};
</script>

<style lang="less" scoped>
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 80px;
}
.sign-toSearch {
  width: 100%;
  height: 94%;
  min-height: 80px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}
.sign-item li {
  border-bottom: 1px solid #ccc;
  background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 12px;
}
.sign-list {
  display: flex;
  p {
    flex: 1;
    word-break: break-all;
    margin: 5px 0;
  }
}
.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
</style>
